import { render, staticRenderFns } from "./PopupAd.vue?vue&type=template&id=426d0614&scoped=true"
import script from "./PopupAd.vue?vue&type=script&lang=js"
export * from "./PopupAd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426d0614",
  null
  
)

export default component.exports